module.exports = __webpack_public_path__ + "static/media/banner.b762df32.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/banner.png
// module id = 625
// module chunks = 0